module.exports = __webpack_public_path__ + "img/connection-left-6.a3532f52.png";